const groupBy = (arr, fn) => arr.map(typeof fn === 'function' ? fn : val => val[fn]).reduce((acc, val, i) => {
  acc[val] = (acc[val] || []).concat(arr[i]);
  return acc;
}, {});
export default groupBy;
flarum.reg.add('fof-reactions', 'forum/utils/groupBy', groupBy);